var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSelectdropdownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.765,
    height: 11.267,
    viewBox: "0 0 19.765 11.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow04",
    transform: "translate(-0.001 -97.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    transform: "translate(0.001 97.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M9.883,108.407A1.38,1.38,0,0,1,8.9,108l-8.5-8.5a1.384,1.384,0,0,1,1.957-1.958l7.52,7.52,7.52-7.52A1.384,1.384,0,1,1,19.36,99.5l-8.5,8.5A1.38,1.38,0,0,1,9.883,108.407Z",
    transform: "translate(-0.001 -97.141)",
    fill: "#fff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectdropdownarrow);
export default __webpack_public_path__ + "static/media/selectdropdownarrow.e4ca63069990b306a908013d503184c2.svg";
export { ForwardRef as ReactComponent };